/* Glowraiders theme script. Vanilla JS, no dependencies. Re-initialises on Shopify theme editor section events. */
(function () {
  'use strict';
  if (window.GR && window.GR.ready) return;
  var origFetch = window.fetch.bind(window);
  var R = window.GR_ROUTES || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' };
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    var ph = /{{\s*(\w+)\s*}}/;
    format = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    function f(n, p, t, d) {
      if (isNaN(n)) return '0';
      var s = (n / 100).toFixed(p).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? d + s[1] : '');
    }
    var m = format.match(ph), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = f(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = f(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = f(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': v = f(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': v = f(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = f(cents, 2, ' ', '.'); break;
      default: v = f(cents, 2, ',', '.');
    }
    return format.replace(ph, v);
  }

  /* ---------------- Cart drawer (Shopify Section Rendering API) ---------------- */
  var Cart = {
    ids: function () { return qsa('[data-gr-cart-section]').map(function (e) { return e.getAttribute('data-gr-cart-section'); }); },
    isOpen: function () { return document.documentElement.classList.contains('gr-cart-open'); },
    sync: function () {
      var o = Cart.isOpen();
      qsa('[data-gr-cart]').forEach(function (d) { d.setAttribute('aria-hidden', o ? 'false' : 'true'); if (o) d.removeAttribute('inert'); else d.setAttribute('inert', ''); });
    },
    open: function () {
      if (!qs('[data-gr-cart]')) { window.location.href = R.cart; return; }
      document.documentElement.classList.add('gr-cart-open'); Cart.sync();
      var c = qs('[data-gr-cart] [data-gr-cart-close]');
      if (c) setTimeout(function () { try { c.focus({ preventScroll: true }); } catch (e) {} }, 60);
    },
    close: function () { document.documentElement.classList.remove('gr-cart-open'); Cart.sync(); },
    render: function (sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var el = document.getElementById('shopify-section-' + id), html = sections[id];
        if (!el || !html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('.shopify-section') || tmp;
        el.innerHTML = fresh.innerHTML;
      });
      Cart.sync(); Cart.count();
    },
    count: function () {
      var src = qs('[data-gr-cart-count]'); if (!src) return;
      var n = parseInt(src.getAttribute('data-gr-cart-count'), 10) || 0;
      qsa('[data-gr-count-badge]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
      qsa('[data-gr-cart-open][data-aria-one]').forEach(function (b) { b.setAttribute('aria-label', (n === 1 ? b.getAttribute('data-aria-one') : b.getAttribute('data-aria-many')).replace('[n]', n)); });
    },
    refresh: function () {
      var ids = Cart.ids(); if (!ids.length) return Promise.resolve();
      return origFetch(window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(Cart.render).catch(function () {});
    },
    change: function (line, qty) {
      var d = qs('[data-gr-cart]'); if (d) d.classList.add('is-busy');
      return origFetch(R.cart_change + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: Cart.ids(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); })
        .then(function (j) { if (j.sections) Cart.render(j.sections); else Cart.refresh(); })
        .catch(function (e) {
          var d2 = qs('[data-gr-cart]'); if (d2) d2.classList.remove('is-busy');
          var er = qs('[data-gr-cart-error]'); if (er) { er.textContent = e.message; er.hidden = false; }
        });
    }
  };

  /* Any cart write made by another script or app (e.g. Kaching Bundles) refreshes the drawer. */
  var refreshT;
  function cartTouched(url) { url = String(url || ''); return ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'].some(function (p) { return url.indexOf(p) > -1; }); }
  function scheduleRefresh(url) {
    clearTimeout(refreshT);
    refreshT = setTimeout(function () { Cart.refresh().then(function () { if (String(url).indexOf('/cart/add') > -1) { Cart.open(); Product.idle(); } }); }, 80);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input);
    var p = origFetch(input, init);
    if (cartTouched(url)) p.then(function (r) { if (r.ok) scheduleRefresh(url); }).catch(function () {});
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (cartTouched(url)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) scheduleRefresh(url); });
    return xOpen.apply(this, arguments);
  };

  /* ---------------- Product purchase ---------------- */
  var Product = {
    busy: false, pending: null, priceText: null, soldOut: false,
    form: function () { return qs('form[data-gr-form]'); },
    label: function (btn, state) {
      if (!btn) return;
      var sp = btn.querySelector('[data-gr-label]'); if (!sp) return;
      var txt;
      if (state === 'busy') txt = sp.getAttribute('data-adding');
      else if (state === 'added') txt = sp.getAttribute('data-added');
      else if (Product.soldOut) txt = sp.getAttribute('data-soldout');
      else txt = sp.getAttribute('data-base') + (sp.getAttribute('data-price') === 'true' && Product.priceText ? ' \u00b7 ' + Product.priceText : '');
      sp.textContent = txt;
      btn.setAttribute('aria-busy', state === 'busy' ? 'true' : 'false');
    },
    idle: function () { Product.busy = false; qsa('[data-gr-buy]').forEach(function (b) { if (b.getAttribute('aria-busy') === 'true') Product.label(b, 'idle'); }); },
    error: function (msg) { qsa('[data-gr-error]').forEach(function (e) { e.textContent = msg || e.getAttribute('data-default'); e.hidden = false; }); },
    clearError: function () { qsa('[data-gr-error]').forEach(function (e) { e.hidden = true; }); },
    buyFrom: function (btn) {
      if (btn.disabled || Product.busy) return;
      var f = Product.form();
      if (f) {
        Product.pending = btn;
        var sb = f.querySelector('button[type=submit]');
        if (f.requestSubmit && sb && !sb.disabled) f.requestSubmit(sb);
        else if (f.requestSubmit) f.requestSubmit();
        else if (sb) sb.click();
        return;
      }
      var vid = btn.getAttribute('data-variant-id'); if (!vid) return;
      var fd = new FormData(); fd.append('id', vid); fd.append('quantity', '1');
      Product.add(btn, fd);
    },
    add: function (btn, fd) {
      if (Product.busy) return; Product.busy = true;
      var ids = Cart.ids();
      if (ids.length) { fd.append('sections', ids.join(',')); fd.append('sections_url', window.location.pathname); }
      Product.label(btn, 'busy'); Product.clearError();
      origFetch(R.cart_add + '.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || ''); return j; }); })
        .then(function (j) {
          Product.busy = false;
          if (j.sections) Cart.render(j.sections); else Cart.refresh();
          Cart.open(); Product.label(btn, 'added');
          setTimeout(function () { Product.label(btn, 'idle'); }, 1800);
        })
        .catch(function (err) { Product.busy = false; Product.label(btn, 'idle'); Product.error(err.message); });
    }
  };

  /* Submit listener on document runs after any form-level listener (apps like Kaching run first). */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-gr-form]')) return;
    if (e.defaultPrevented) { Product.pending = null; return; }
    e.preventDefault();
    var btn = Product.pending || e.submitter || f.querySelector('[data-gr-buy]');
    Product.pending = null;
    Product.add(btn, new FormData(f));
  });

  function initGallery(g) {
    if (!g) return null;
    var track = qs('[data-gr-track]', g); if (!track) return null;
    var slides = qsa('.gr-slide', track), n = slides.length, idx = 0, raf;
    var count = qs('[data-gr-count]', g), thumbs = qsa('[data-gr-thumb]', g);
    function mark(i) {
      idx = i;
      if (count) count.textContent = (i + 1) + ' / ' + n;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      slides.forEach(function (s, j) { var v = s.querySelector('video'); if (v && j !== i && !v.paused) v.pause(); });
    }
    function go(i) { if (!n) return; var k = ((i % n) + n) % n; mark(k); track.scrollTo({ left: k * track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' }); }
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / (track.clientWidth || 1)); if (i !== idx && i >= 0 && i < n) mark(i); });
    }, { passive: true });
    function fs(on) {
      g.classList.toggle('is-fs', on);
      document.documentElement.classList.toggle('gr-fs', on);
      var b = qs('[data-gr-fs]', g); if (b) b.setAttribute('aria-label', on ? b.getAttribute('data-close') : b.getAttribute('data-open'));
      requestAnimationFrame(function () { track.scrollLeft = idx * track.clientWidth; });
    }
    g.addEventListener('click', function (e) {
      if (e.target.closest('[data-gr-prev]')) go(idx - 1);
      else if (e.target.closest('[data-gr-next]')) go(idx + 1);
      else if (e.target.closest('[data-gr-fs]')) fs(!g.classList.contains('is-fs'));
      else { var th = e.target.closest('[data-gr-thumb]'); if (th) go(parseInt(th.getAttribute('data-gr-thumb'), 10)); }
    });
    var viewer = qs('[data-gr-viewer]', g);
    if (viewer) viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    function onResize() { track.scrollLeft = idx * track.clientWidth; }
    window.addEventListener('resize', onResize);
    return {
      fs: fs, go: go,
      isFs: function () { return g.classList.contains('is-fs'); },
      goToMedia: function (id) { for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-media-id') === String(id)) { go(i); return; } } },
      destroy: function () { window.removeEventListener('resize', onResize); if (g.classList.contains('is-fs')) fs(false); }
    };
  }

  function initProduct(sec) {
    var jsonEl = qs('[data-gr-product-json]', sec); if (!jsonEl) return null;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return null; }
    var fmt = sec.getAttribute('data-money-format') || '';
    var form = qs('form[data-gr-form]', sec), idInput = form && form.querySelector('input[name=id]');
    var gallery = initGallery(qs('[data-gr-gallery]', sec));
    function byId(id) { for (var i = 0; i < product.variants.length; i++) { if (String(product.variants[i].id) === String(id)) return product.variants[i]; } return null; }
    function apply(v) {
      if (idInput) idInput.value = v.id;
      Product.priceText = formatMoney(v.price, fmt); Product.soldOut = !v.available;
      qsa('[data-gr-price]').forEach(function (el) { el.textContent = Product.priceText; });
      var cmp = v.compare_at_price && v.compare_at_price > v.price;
      qsa('[data-gr-compare]').forEach(function (el) { el.textContent = cmp ? formatMoney(v.compare_at_price, fmt) : ''; });
      qsa('[data-gr-compare-wrap]').forEach(function (el) { el.hidden = !cmp; });
      qsa('[data-gr-save]').forEach(function (el) {
        if (!cmp) return;
        el.textContent = el.getAttribute('data-mode') === 'percent' ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : formatMoney(v.compare_at_price - v.price, fmt);
      });
      qsa('[data-gr-buy]').forEach(function (b) { b.disabled = !v.available; b.setAttribute('data-variant-id', v.id); Product.label(b, 'idle'); });
      if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);
    }
    var picker = qs('[data-gr-variants]', sec);
    if (picker) picker.addEventListener('change', function () {
      var sel = qsa('fieldset', picker).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      var v = product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!v) { Product.soldOut = true; qsa('[data-gr-buy]').forEach(function (b) { b.disabled = true; Product.label(b, 'idle'); }); return; }
      apply(v);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
    });
    if (idInput) idInput.addEventListener('change', function () { var v = byId(idInput.value); if (v) apply(v); });
    var qty = qs('[data-gr-qty-input]', sec);
    sec.addEventListener('click', function (e) {
      var s = e.target.closest('[data-gr-qty-step]'); if (!s || !qty) return;
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(s.getAttribute('data-gr-qty-step'), 10));
    });
    var cur = (idInput && byId(idInput.value)) || product.variants[0];
    if (cur) apply(cur);
    var sticky = qs('[data-gr-sticky]', sec), io = null, finEl = null, past = false, fin = false;
    var buy = qs('#gr-buy', sec);
    function setSticky() {
      var on = past && !fin;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      qsa('button', sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    function observeFinal() {
      if (!io) return;
      var f = document.getElementById('gr-final');
      if (f !== finEl) { if (finEl) io.unobserve(finEl); finEl = f; fin = false; if (f) io.observe(f); }
    }
    if (sticky && buy && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.target === buy) past = !en.isIntersecting && en.boundingClientRect.top < 0;
          else fin = en.isIntersecting || en.boundingClientRect.top < 0;
        });
        setSticky();
      });
      io.observe(buy); observeFinal();
    }
    return { gallery: gallery, observeFinal: observeFinal, destroy: function () { if (io) io.disconnect(); if (gallery) gallery.destroy(); } };
  }

  function initVideos(sec) {
    var cards = qsa('[data-gr-vcard]', sec), vids = [], userVid = false, visible = {};
    var auto = sec.getAttribute('data-autoplay') === 'true';
    cards.forEach(function (card, i) {
      var v = qs('video[data-gr-video]', card); vids[i] = v || null; if (!v) return;
      var fill = qs('.gr-seek__fill', card), seek = qs('[data-gr-seek]', card);
      function set(c, on) { card.classList.toggle(c, on); }
      v.addEventListener('play', function () { set('is-playing', true); set('is-error', false); });
      v.addEventListener('pause', function () { set('is-playing', false); set('is-loading', false); });
      v.addEventListener('waiting', function () { set('is-loading', true); });
      v.addEventListener('playing', function () { set('is-loading', false); set('is-playing', true); });
      v.addEventListener('error', function () { set('is-error', true); set('is-loading', false); set('is-playing', false); }, true);
      v.addEventListener('timeupdate', function () {
        if (!v.duration || !fill) return; var p = v.currentTime / v.duration;
        fill.style.width = (p * 100).toFixed(1) + '%'; if (seek) seek.setAttribute('aria-valuenow', Math.round(p * 100));
      });
      function toggle() {
        userVid = true;
        if (v.paused) {
          vids.forEach(function (o, j) { if (o && j !== i && !o.paused) o.pause(); });
          set('is-error', false);
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () { set('is-error', true); });
        } else v.pause();
      }
      v.addEventListener('click', toggle);
      var play = qs('[data-gr-play]', card); if (play) play.addEventListener('click', toggle);
      var err = qs('.gr-verr', card); if (err) err.addEventListener('click', function () { v.load(); toggle(); });
      var mute = qs('[data-gr-mute]', card);
      function syncMute() { set('is-unmuted', !v.muted); if (mute) { mute.setAttribute('aria-pressed', v.muted ? 'true' : 'false'); mute.setAttribute('aria-label', v.muted ? mute.getAttribute('data-on') : mute.getAttribute('data-off')); } }
      if (mute) mute.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; syncMute(); });
      v.addEventListener('volumechange', syncMute); syncMute();
      if (seek) {
        seek.addEventListener('click', function (e) { if (!v.duration) return; var r = seek.getBoundingClientRect(); v.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * v.duration; });
        seek.addEventListener('keydown', function (e) {
          if (!v.duration) return;
          if (e.key === 'ArrowRight') v.currentTime = Math.min(v.duration, v.currentTime + 2);
          if (e.key === 'ArrowLeft') v.currentTime = Math.max(0, v.currentTime - 2);
        });
      }
    });
    function autoplay() {
      if (!auto || userVid || reduced()) return;
      var keys = Object.keys(visible).map(Number).filter(function (i) { return cards[i] && cards[i].getAttribute('data-autoplay') === 'true'; }).sort(function (a, b) { return a - b; });
      var first = keys.length ? keys[0] : -1;
      vids.forEach(function (v, i) {
        if (!v) return;
        if (i === first) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }
    var vio = null;
    if ('IntersectionObserver' in window) {
      vio = new IntersectionObserver(function (es) {
        es.forEach(function (en) { var i = vids.indexOf(en.target); if (en.intersectionRatio >= 0.6) visible[i] = true; else { delete visible[i]; if (!en.target.paused) en.target.pause(); } });
        autoplay();
      }, { threshold: [0, 0.6] });
      vids.forEach(function (v) { if (v) vio.observe(v); });
    }
    var track = qs('[data-gr-vtrack]', sec), dots = qsa('[data-gr-dot]', sec);
    if (track) track.addEventListener('scroll', function () {
      var c = track.firstElementChild; if (!c) return;
      var i = Math.round(track.scrollLeft / (c.offsetWidth + 16));
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
    }, { passive: true });
    return {
      destroy: function () { if (vio) vio.disconnect(); vids.forEach(function (v) { if (v) v.pause(); }); },
      select: function (id) { cards.forEach(function (c) { if (c.getAttribute('data-block-id') === id && track) track.scrollTo({ left: c.offsetLeft - 20, behavior: 'smooth' }); }); }
    };
  }

  function initModes(sec) {
    var list = qs('[data-gr-modes]', sec), panel = qs('[data-gr-mode-panel]', sec);
    if (!list || !panel) return null;
    var tabs = qsa('[role=tab]', list);
    var tplB = qs('[data-tpl-bullet]', panel), tplH = qs('[data-tpl-heart]', panel);
    var bullet = tplB ? tplB.innerHTML : '', heart = tplH ? tplH.innerHTML : '';
    function rep(s, n) { var o = ''; for (var i = 0; i < n; i++) o += s; return o; }
    function sel(i, focus) {
      var t = tabs[i]; if (!t) return;
      tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); x.tabIndex = j === i ? 0 : -1; });
      var b = parseInt(t.getAttribute('data-bullets'), 10) || 0, l = parseInt(t.getAttribute('data-lives'), 10) || 0, P = function (a) { return panel.getAttribute(a); };
      panel.style.setProperty('--m', t.getAttribute('data-color'));
      qs('[data-idx]', panel).textContent = P('data-idx-label') + ' ' + (i + 1) + ' / ' + tabs.length;
      qs('[data-bullets]', panel).innerHTML = rep(bullet, b);
      qs('[data-hearts]', panel).innerHTML = rep(heart, l);
      qs('[data-bullets-label]', panel).textContent = b + ' ' + (b === 1 ? P('data-bullet-one') : P('data-bullet-many'));
      qs('[data-lives-label]', panel).textContent = l + ' ' + (l === 1 ? P('data-life-one') : P('data-life-many'));
      qs('[data-name]', panel).textContent = t.getAttribute('data-name');
      qs('[data-desc]', panel).textContent = t.getAttribute('data-desc');
      if (focus) t.focus();
    }
    list.addEventListener('click', function (e) { var t = e.target.closest('[role=tab]'); if (t) sel(tabs.indexOf(t)); });
    list.addEventListener('keydown', function (e) {
      var cur = 0; tabs.forEach(function (t, j) { if (t.getAttribute('aria-selected') === 'true') cur = j; });
      var n = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (cur + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (cur - 1 + tabs.length) % tabs.length;
      else return;
      e.preventDefault(); sel(n, true);
    });
    return { select: function (id) { tabs.forEach(function (t, j) { if (t.getAttribute('data-block-id') === id) sel(j); }); } };
  }

  function initHit(sec) {
    var hit = qs('[data-gr-hit]', sec); if (!hit) return null;
    var max = parseInt(hit.getAttribute('data-lives'), 10) || 5, lives = max, t;
    var pips = qsa('.gr-pip', hit), status = qs('[data-status]', hit), btns = qsa('[data-gr-tag]', hit);
    function A(a) { return hit.getAttribute(a) || ''; }
    function render() {
      pips.forEach(function (p, i) { p.classList.toggle('is-on', i < lives); });
      if (status) status.textContent = lives > 0 ? A('data-left').replace('[n]', lives) : A('data-out');
      hit.classList.toggle('is-out', lives === 0);
      var lbl = lives > 0 ? A('data-tag') : A('data-respawn');
      btns.forEach(function (b) { if (b.getAttribute('data-gr-tag') === 'text') b.textContent = lbl; b.setAttribute('aria-label', lbl); });
    }
    function tag() {
      if (lives <= 0) { lives = max; render(); return; }
      lives--; hit.classList.add('is-hit');
      clearTimeout(t); t = setTimeout(function () { hit.classList.remove('is-hit'); }, 420);
      render();
    }
    btns.forEach(function (b) { b.addEventListener('click', tag); });
    render();
    return { destroy: function () { clearTimeout(t); } };
  }

  function initFaq(sec) {
    var items = qsa('[data-gr-faq]', sec); if (!items.length) return null;
    function set(item, open) {
      item.classList.toggle('is-open', open);
      var b = qs('[data-gr-faq-btn]', item), p = qs('.gr-acc__panel', item);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) p.removeAttribute('inert'); else p.setAttribute('inert', '');
    }
    var btns = items.map(function (i) { return qs('[data-gr-faq-btn]', i); });
    items.forEach(function (item, idx) {
      var b = btns[idx];
      b.addEventListener('click', function () { var open = !item.classList.contains('is-open'); items.forEach(function (o) { set(o, o === item ? open : false); }); });
      b.addEventListener('keydown', function (e) {
        var n = -1;
        if (e.key === 'ArrowDown') n = (idx + 1) % btns.length;
        else if (e.key === 'ArrowUp') n = (idx - 1 + btns.length) % btns.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = btns.length - 1;
        if (n < 0) return; e.preventDefault(); btns[n].focus();
      });
    });
    return { select: function (id) { items.forEach(function (o) { set(o, o.getAttribute('data-block-id') === id); }); } };
  }

  var INITS = {
    product: initProduct,
    videos: initVideos,
    faq: initFaq,
    benefits: function (s) { var m = initModes(s), h = initHit(s); return { select: function (id) { if (m) m.select(id); }, destroy: function () { if (h) h.destroy(); } }; }
  };
  var ctrls = new Map();
  function init(scope) {
    var els = qsa('[data-gr-init]', scope);
    if (scope.matches && scope.matches('[data-gr-init]')) els.push(scope);
    els.forEach(function (el) {
      if (ctrls.has(el)) return;
      var fn = INITS[el.getAttribute('data-gr-init')];
      if (fn) { try { ctrls.set(el, fn(el) || {}); } catch (err) { console.error('[Glowraiders]', err); } }
    });
  }
  function destroy(scope) { ctrls.forEach(function (c, el) { if (scope.contains(el)) { if (c.destroy) c.destroy(); ctrls.delete(el); } }); }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-gr-cart-open]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-gr-cart-close]')) { e.preventDefault(); Cart.close(); return; }
    var ln = t.closest('[data-gr-line]');
    if (ln) { e.preventDefault(); Cart.change(parseInt(ln.getAttribute('data-gr-line'), 10), parseInt(ln.getAttribute('data-qty'), 10)); return; }
    var buy = t.closest('[data-gr-buy]');
    if (buy && buy.type !== 'submit') { e.preventDefault(); Product.buyFrom(buy); return; }
    if (buy && buy.type === 'submit') { Product.pending = buy; }
    var a = t.closest('a[href]');
    if (a) {
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) !== '#' || h.length < 2) return;
      var el = document.getElementById(h.slice(1)); if (!el) return;
      e.preventDefault(); Cart.close();
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 68, behavior: reduced() ? 'auto' : 'smooth' });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Cart.close();
    ctrls.forEach(function (c) { if (c.gallery && c.gallery.isFs()) c.gallery.fs(false); });
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); Cart.sync(); Cart.count(); ctrls.forEach(function (c) { if (c.observeFinal) c.observeFinal(); }); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector && e.target.querySelector('[data-gr-cart-section]')) Cart.open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector && e.target.querySelector('[data-gr-cart-section]')) Cart.close(); });
  document.addEventListener('shopify:block:select', function (e) { ctrls.forEach(function (c, el) { if (c.select && el.contains(e.target)) c.select(e.detail.blockId); }); });

  function boot() {
    init(document); Cart.sync(); Cart.count();
    if (window.location.hash === '#cart') { Cart.open(); try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.GR = { ready: true, Cart: Cart, Product: Product, formatMoney: formatMoney };
})();
